var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentImgD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#EDE8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1975_30)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4628 15.1423C20.9571 16.7227 20.2457 18.4019 19.3238 19.3238C18.4019 20.2457 16.7226 20.9571 15.1423 21.4628C15.0419 21.4949 14.9418 21.5262 14.8424 21.5567C14.5733 21.6392 14.3087 21.7157 14.053 21.7861C13.9497 21.8145 13.8479 21.8419 13.7478 21.8684C13.2911 21.9891 13.2911 22.8202 13.7478 22.9409C13.8479 22.9673 13.9497 22.9948 14.053 23.0232C14.3087 23.0936 14.5733 23.17 14.8424 23.2525C14.9418 23.283 15.0419 23.3143 15.1423 23.3465C16.7226 23.8522 18.4019 24.5635 19.3238 25.4854C20.2457 26.4073 20.9571 28.0866 21.4628 29.6669C21.4949 29.7674 21.5262 29.8674 21.5567 29.9668C21.6392 30.2359 21.7156 30.5005 21.786 30.7562C21.8145 30.8595 21.8419 30.9614 21.8684 31.0615C21.9891 31.5182 22.8201 31.5182 22.9408 31.0615C22.9673 30.9614 22.9947 30.8595 23.0232 30.7562C23.0936 30.5005 23.17 30.2359 23.2525 29.9668C23.283 29.8674 23.3143 29.7674 23.3464 29.6669C23.8521 28.0866 24.5635 26.4073 25.4854 25.4854C26.4073 24.5635 28.0866 23.8522 29.6669 23.3465C29.7673 23.3143 29.8674 23.283 29.9668 23.2525C30.2359 23.17 30.5005 23.0936 30.7562 23.0232C30.8595 22.9948 30.9613 22.9673 31.0614 22.9409C31.5181 22.8202 31.5181 21.9891 31.0614 21.8684C30.9613 21.8419 30.8595 21.8145 30.7562 21.7861C30.5005 21.7157 30.2359 21.6392 29.9668 21.5567C29.8674 21.5262 29.7673 21.4949 29.6669 21.4628C28.0866 20.9571 26.4073 20.2457 25.4854 19.3238C24.5635 18.4019 23.8521 16.7227 23.3464 15.1423C23.3143 15.0419 23.283 14.9419 23.2525 14.8425C23.17 14.5733 23.0936 14.3087 23.0232 14.053C22.9947 13.9497 22.9673 13.8479 22.9408 13.7478C22.8201 13.2911 21.9891 13.2911 21.8684 13.7478C21.8419 13.8479 21.8145 13.9497 21.786 14.053C21.7156 14.3087 21.6392 14.5733 21.5567 14.8425C21.5262 14.9419 21.4949 15.0419 21.4628 15.1423Z",
    fill: "url(#paint0_linear_1975_30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2384 8.91602C13.098 8.49467 12.502 8.49467 12.3615 8.91602L11.8655 10.4041C11.6355 11.0941 11.094 11.6355 10.404 11.8655L8.91599 12.3616C8.49464 12.502 8.49464 13.098 8.91599 13.2385L10.404 13.7345C11.0941 13.9645 11.6355 14.5059 11.8655 15.196L12.3615 16.684C12.502 17.1053 13.098 17.1053 13.2384 16.684L13.7344 15.196C13.9644 14.5059 14.5059 13.9645 15.1959 13.7345L16.684 13.2385C17.1053 13.098 17.1053 12.502 16.684 12.3616L15.1959 11.8655C14.5059 11.6355 13.9644 11.0941 13.7344 10.4041L13.2384 8.91602Z",
    fill: "url(#paint1_linear_1975_30)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1975_30",
    x1: 20.002,
    y1: 8.60001,
    x2: 20.002,
    y2: 31.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1975_30",
    x1: 20.002,
    y1: 8.60001,
    x2: 20.002,
    y2: 31.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1975_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentImgD);
export default __webpack_public_path__ + "static/media/payment_img_d.a93dc2d5b29c79e70916e9f71d12d714.svg";
export { ForwardRef as ReactComponent };